import React, {useState} from 'react';
import {Checkbox, FormControlLabel, Stack, Typography} from '@mui/material';
import {Drawer} from 'presentation/components/Drawer';
import {translations} from 'presentation/translations-new';
import {AddressDependentAssignmentDrawerProps} from './types';
import {formatText} from 'presentation/utils/formatText';

const {assignToDependent} = translations['pt-br'].privateFlow.bookingFlow.location;

export function AddressDependentAssignmentDrawer({
	isOpen,
	onClose,
	dependents,
	onConfirm,
	isLoading = false,
}: AddressDependentAssignmentDrawerProps) {
	const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

	const allSelected = selectedIds.size === dependents.length && dependents.length > 0;
	const noneSelected = selectedIds.size === 0;

	const handleToggleAll = () => {
		if (allSelected) {
			setSelectedIds(new Set());
		} else {
			setSelectedIds(new Set(dependents.map(d => d.cdPessoaC)));
		}
	};

	const handleToggle = (cdPessoaC: string) => {
		setSelectedIds(prev => {
			const next = new Set(prev);
			if (next.has(cdPessoaC)) {
				next.delete(cdPessoaC);
			} else {
				next.add(cdPessoaC);
			}
			return next;
		});
	};

	const handleClose = () => {
		setSelectedIds(new Set());
		onClose();
	};

	const handleConfirm = () => {
		const selected = dependents.filter(d => selectedIds.has(d.cdPessoaC));
		onConfirm(selected);
		setSelectedIds(new Set());
	};

	return (
		<Drawer.Root open={isOpen} onOpen={() => {}} onClose={handleClose}>
			<Drawer.Header title={assignToDependent.drawerTitle} onClose={handleClose} />
			<Drawer.Content>
				<Typography variant="body2" mb={2}>
					{assignToDependent.drawerDescription}
				</Typography>
				<Stack>
					<FormControlLabel
						label={assignToDependent.selectAll}
						control={
							<Checkbox
								checked={allSelected}
								indeterminate={!allSelected && !noneSelected}
								onChange={handleToggleAll}
							/>
						}
					/>
					<Stack pl={4}>
						{dependents.map(dependent => (
							<FormControlLabel
								key={dependent.cdPessoaC}
								label={formatText(dependent.nmUsuarioC)}
								control={
									<Checkbox
										checked={selectedIds.has(dependent.cdPessoaC)}
										onChange={() => handleToggle(dependent.cdPessoaC)}
									/>
								}
							/>
						))}
					</Stack>
				</Stack>
			</Drawer.Content>
			<Drawer.Footer
				firstButtonTitle={assignToDependent.cancelButton}
				firstButtonOnClick={handleClose}
				secondButtonTitle={assignToDependent.confirmButton}
				secondButtonOnClick={handleConfirm}
				secondButtonDisabled={noneSelected || isLoading}
				secondButtonIsLoading={isLoading}
			/>
		</Drawer.Root>
	);
}
